var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 52,
    viewBox: "0 0 39 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2034_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5157 0C12.411 0 7.16023 3.32109 3.0368 9.24219C2.28523 10.3188 2.51883 11.7914 3.56492 12.5836L7.94226 15.9047C8.99851 16.707 10.4915 16.5141 11.3243 15.4883C13.8634 12.2992 15.7524 10.4711 19.7337 10.4711C22.8618 10.4711 26.7212 12.482 26.7212 15.5086C26.7212 17.8039 24.8321 18.9719 21.7446 20.7086C18.1493 22.7297 13.386 25.2383 13.386 31.5148V32.5C13.386 33.8508 14.4727 34.9375 15.8235 34.9375H23.1868C24.5376 34.9375 25.6243 33.8508 25.6243 32.5V31.9109C25.6243 27.5539 38.3501 27.3813 38.3501 15.6C38.3399 6.73359 29.1384 0 20.5157 0ZM19.5001 37.9336C15.6204 37.9336 12.4618 41.0922 12.4618 44.9719C12.4618 48.8516 15.6204 52.0102 19.5001 52.0102C23.3798 52.0102 26.5384 48.8516 26.5384 44.9719C26.5384 41.0922 23.3798 37.9336 19.5001 37.9336Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2034_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.258dfb1d20dbf836b6b64654e10eed62.svg";
export { ForwardRef as ReactComponent };